import { render, staticRenderFns } from "./MyInventories.vue?vue&type=template&id=3c2d8d26&"
import script from "./MyInventories.vue?vue&type=script&lang=js&"
export * from "./MyInventories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports